import {
  doc,
  setDoc,
  collection,
  query,
  where,
  getDocs
} from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";

export const Add_favorites = async (data) => {
  const { docuid, favorites_type } = data || {};
 const servicetablename = "accountingfinancedb";
  if (!docuid?.trim()) return { success: false, error: "Missing favoritesuid" };
  if (!favorites_type?.trim()) return { success: false, error: "Missing type." };

  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");
  const select_company_uid = Cookies.get("select_company_uid");

  if (!sessiontoken) return { success: false, error: "Session expired. Please relogin." };
  if (!guid) return { success: false, error: "Login expired. Please relogin." };
  if (!select_company_uid) return { success: false, error: "Contact service provider." };

  try {
    // Check company
    const companySnap = await getDocs(
      query(collection(db, servicetablename), where("companyuid", "==", select_company_uid))
    );
    if (companySnap.empty)
      return { success: false, error: "Company does not exist." };

    const favoritesCol = collection(
      db,
      servicetablename,
      select_company_uid,
      "favorites"
    );

    // Check for existing record
    const duplicateQuery = query(
      favoritesCol,
      where("docuid", "==", docuid),
      where("guid", "==", guid)
    );
    const duplicateSnap = await getDocs(duplicateQuery);

    let docRef;
    let status;

    if (!duplicateSnap.empty) {
      // Toggle existing status
      const oldDoc = duplicateSnap.docs[0];
      const oldData = oldDoc.data();

      status = !oldData.status; // toggle true/false
      docRef = oldDoc.ref; // update same doc
    } else {
      // New entry
      const favoritesid = docuid + "_" + guid; // One document per docuid+guid
      docRef = doc(
        db,
        servicetablename,
        select_company_uid,
        "favorites",
        favoritesid
      );
      status = true; // default for first time
    }

    const payload = {
      ...data,
      docuid,
      favorites_type,
      guid,
      status,
      companyuid: select_company_uid,
      date_time_update: new Date()
    };

    await setDoc(docRef, payload, { merge: true });

    return { success: true, message: "Saved successfully." };

  } catch (err) {
    console.error("Error saving favorites:", err);
    return { success: false, error: err?.message || "Unknown error" };
  }
};
